// The `FAQS` component displays a list of frequently asked questions (FAQs) along
// with their answers. It renders the FAQ section title, followed by iterating over
// the `questions` array from the `agContent` prop, passing each question and answer
// to the `QuestionAnswer` component. At the bottom, a button is provided to navigate
// users back to the club home page. The component uses Next.js's `useRouter` for routing
// and is styled with Tailwind CSS for layout and design.

import React from 'react';
import { FAQ } from 'types/next';
import QuestionAnswer from './question-answer';
import { useRouter } from 'next/navigation';

interface FAQSProps {
  agContent: FAQ;
}

const FAQS = ({ agContent }: FAQSProps) => {
  const router = useRouter();

  return (
    <div className="faq-section">
      <h2 className="mb-30 text-start text-36 font-bold">{agContent?.name}</h2>
      {agContent?.questions.map((faqItem, index) => (
        <QuestionAnswer key={index} question={faqItem.question} answer={faqItem.answer} />
      ))}
      <div className="flex justify-center">
        <button
          className="my-30 h-[42px] w-[215px] bg-[#1dce8f] px-16 py-10 text-14 font-bold"
          onClick={() => router.push('/club-page')}
        >
          BACK TO CLUB HOME
        </button>
      </div>
    </div>
  );
};

export default FAQS;
